export const eventsFormErrors = {
  title: {
    required: 'El título del evento es obligatorio',
    minlength: 'El título debe tener al menos 3 caracteres',
    maxlength: 'El título no puede exceder los 100 caracteres'
  },
  subtitle: {
    maxlength: 'El subtítulo no puede exceder los 200 caracteres'
  },
  segmentationType: {
    required: 'Debe seleccionar quién está invitado al evento'
  },
  link: {
    required: 'El enlace del evento es obligatorio',
    invalidUrl: 'Debe proporcionar una URL válida'
  },
  startDate: {
    required: 'La fecha de inicio es obligatoria',
    startDateBeforeToday: 'La fecha de inicio no puede ser anterior a hoy',
    startDateAfterEndDate: 'La fecha de inicio debe ser anterior a la fecha de fin'
  },
  endDate: {
    endDateBeforeStartDate: 'La fecha de fin debe ser posterior a la fecha de inicio',
    endDateBeyondWeekEnd: 'La fecha de fin no puede ir más allá del domingo de la semana de inicio a las 23:59'
  },
  'advanced.buttonText': {
    required: 'El texto del botón es obligatorio',
    minlength: 'El texto del botón debe tener al menos 2 caracteres',
    maxlength: 'El texto del botón no puede exceder los 50 caracteres'
  },
  'advanced.buttonLink': {
    invalidUrl: 'Debe proporcionar una URL válida para el enlace del botón'
  },
  'advanced.platform': {
    required: 'Debe seleccionar una plataforma para el evento'
  },
  'advanced.recurrence': {
    required: 'Debe seleccionar el tipo de recurrencia'
  }
};
